/**
 * @desc 修改发放领用人员
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
  /** name */
  name: string;
}

export function request(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/web/labour/updatePerson',

    params,
  });
}

export function mock(params: Params): Promise<defs.StandardReturn<string>> {
  return defHttp.get({
    url: '/mock/web/labour/updatePerson',

    params,
  });
}
